import axios from 'axios'

const defaultState = () => {
  return {
    user: {},
    bans: [],
    followList: [],
    blockList: [],
    purchaseID: [],
    likeID: [],
    token: localStorage.getItem('token'),
    haveNotification: false
  }
}

const state = defaultState()

const getters = {
  isLogin: state => !!state.token && !!state.user.nickname,
  verifying: state => !state.user.identity_verified && (state.user.member_identity && !state.user.member_identity.denied),
  purchaseID: state => state.purchaseID.filter(id => !!id),
  likeID: state => state.likeID.filter(id => !!id),
  all_verified: state => state.user.identity_verified && state.user.tel_verified
}

const mutations = {
  login(state, token) {
    state.token = token
    localStorage.setItem('token', token)
  },
  logout(state) {
    localStorage.setItem('token', '')
    Object.assign(state, defaultState())
  },
  setUser(state, user) {
    state.user = user
  },
  setToken(state, token) {
    state.token = token
    localStorage.setItem('token', token)
  },
  setNickname(state, name) {
    state.user.nickname = name
  },
  setBans(state, bans) {
    state.bans = bans
  },
  setFollowList(state, followList) {
    state.followList = followList
  },
  setBlockList(state, blockList) {
    state.blockList = blockList
  },
  setPurchaseID(state, purchaseID) {
    state.purchaseID = purchaseID
  },
  setLikeID(state, likeID) {
    state.likeID = likeID
  },
  setHaveNotification(state, status) {
    state.haveNotification = status
  }
}

const actions = {
  login({ commit }, token) {
    commit('login', token)
  },
  logout({ commit }) {
    commit('logout')
  },
  setUser({ commit }, user) {
    commit('setUser', user)
  },
  setToken({ commit, state }, token) {
    commit('setToken', token)
  },
  getUserInformation({ commit, state }, target=null) {
    return new Promise(function(resolve, reject) {
      if(state.token) {
        axios.get('/member').then(response => {
          if(target == 'wallpaper') {
            response.data.wallpaper = response.data.wallpaper ? response.data.wallpaper + `?t=${Date.now()}` : ''
          }
          else if(target == 'usericon') {
            response.data.usericon = response.data.usericon ? response.data.usericon + `?t=${Date.now()}` : ''
          }
          commit('setUser', response.data)
          resolve()
        }).catch(() => {
          reject()
        })
      }
      else {
        reject()
      }
    })
  },
  sendVerifyMail({ commit }) {
    return axios('/member/email/send/verification')
  },
  sendVerifyTel({ commit }, tel) {
    return axios(`/member/SMS/send/verification?tel=${tel}`)
  },
  setNickname({ commit }, name) {
    commit('setNickname', name)
  },
  getBans({ commit }) {
    return axios('/member/bans?page=1&size=9999').then(response => {
      commit('setBans', response.data.data)
    })
  },
  getFollowList({ commit }) {
    return axios('/member/favorite').then(response => {
      commit('setFollowList', response.data)
    })
  },
  getBlockList({ commit }) {
    return axios('/member/block').then(response => {
      commit('setBlockList', response.data)
    })
  },
  getPurchaseID({ commit }) {
    return axios('/member/online/purchase/ids').then(response => {
      commit('setPurchaseID', response.data)
    })
  },
  getLikeID({ commit }) {
    return axios('/member/praise').then(response => {
      commit('setLikeID', response.data)
    })
  },
  setHaveNotification({ commit }, status) {
    commit('setHaveNotification', status)
  },
  follow({ commit }, seller_id, callback) {
    return axios.post('/member/favorite', {
      seller_id: seller_id
    }).then(response => {
      this.dispatch('user/getFollowList')
      callback ? callback() : null
    })
  },
  block({ commit }, seller_id, callback) {
    return axios.post('/member/block', {
      seller_id: seller_id
    }).then(response => {
      this.dispatch('user/getBlockList')
      callback ? callback() : null
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}